import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "../../AdminList.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import resetPassword from "@icons/ic-reset-password.svg";
import "../../AdminList.scss";
import AddEditAdmin from "../../../AddEditAdmin";

const ACTION_DISABLE = "disable";
const ACTION_RESET_PASSWORD = "resetPassword";

const Action = (props) => {
  const { t, data, updateRefeshStatus } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const [isAddAdminPopupVisible, setAddAdminPopupVisible] = useState(false);
  const handleDisable = () => {
    setPendingAction(ACTION_DISABLE);
    setConfirmVisibility(true);
  };

  const handleResetPassword = () => {
    setPendingAction(ACTION_RESET_PASSWORD);
    setConfirmVisibility(true);
  };

  const editAdmin = () => {
    setAddAdminPopupVisible(true);
  };
  const closeAdminCreationPopup = () => {
    setAddAdminPopupVisible(false);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
    setPendingAction(null);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (!isConfirm) return;

    if (pendingAction === ACTION_RESET_PASSWORD) {
      axios
        .post(`/general/admins/${data.id}/resetPassword`)
        .then(() => {
          updateRefeshStatus(true);
        })
        .catch((error) => {
          updateRefeshStatus(true);
          handleApiError(error);
        })
        .finally(() => {
          setActionConfirmStatus(false);
          setPendingAction(null);
        });
      return;
    }

    if (pendingAction === ACTION_DISABLE) {
      const formStatus = data.isActive ? "0" : 1;
      axios
        .put(`/general/admins/${data.id}/updateStatus`, formStatus)
        .then(() => {
          updateRefeshStatus(true);
        })
        .catch((error) => {
          updateRefeshStatus(true);
          handleApiError(error);
        })
        .finally(() => {
          setActionConfirmStatus(false);
          setPendingAction(null);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const getPopupTitle = () => {
    if (pendingAction === ACTION_RESET_PASSWORD) {
      return t("ADMIN_CONFIRMATION_BOX_RESET_PASSWORD");
    }
    return data.isActive == 0
      ? t("ADMIN_CONFIRMATION_BOX_ENABLE")
      : t("ADMIN_CONFIRMATION_BOX_DELETE");
  };

  const getPopupMessage = () => {
    if (pendingAction === ACTION_RESET_PASSWORD) {
      return t("ADMIN_CONFIRMATION_BOX_RESET_PASSWORD_CONTENT");
    }
    return data.isActive == 0
      ? t("ADMIN_CONFIRMATION_BOX_ENABLE_CONTENT")
      : t("ADMIN_CONFIRMATION_BOX_DELETE_CONTENT");
  };

  return (
    <ButtonContainer>
      <div>
        {data.isActive == 1 && (
          <Image
            src={editIcon}
            onClick={editAdmin}
            title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
            alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
            className="admins-list__image-action-icon"
          />
        )}
        {data.isActive == 1 && (
          <Image
            src={resetPassword}
            onClick={handleResetPassword}
            title={t("ACTION_TOOLTIP_RESET_PASSWORD")}
            alt={t("ACTION_TOOLTIP_RESET_PASSWORD")}
            className="admins-list__image-action-icon"
          />
        )}
        {data.isActive == 1 && (
          <Image
            src={deleteIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="admins-list__image-action-icon"
          />
        )}
        {data.isActive == 0 && (
          <Image
            src={activateIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="admins-list__image-action-icon"
          />
        )}
      </div>

      {isAddAdminPopupVisible && (
        <AddEditAdmin
          title={data.firstName + " " + data.lastName}
          onClose={closeAdminCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedAdmin={data}
          isEditMode
          id={data.id}
        />
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={getPopupTitle()}
          message={getPopupMessage()}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(Action);
